import { render, staticRenderFns } from "./ProductListTemplate.vue?vue&type=template&id=0bbc7cb2&"
import script from "./ProductListTemplate.vue?vue&type=script&lang=js&"
export * from "./ProductListTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports